import * as React from 'react';

import { Administrator } from 'javascript/models';
import { Manager } from 'javascript/models';
import { User } from 'javascript/models';

const currentUserContext: Administrator | Manager | User | null = null;

export default React.createContext(currentUserContext);
